'use client';

import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';
import { cn } from '@/lib/utils';

export interface OtherTransferBeneficiary {
  contactId: number;
  name: string;
}

export function OtherBeneficiaryPanel({
  contacts,
  selected,
  onToggle
}: {
  contacts: Array<{ id: number; firstName: string; lastName: string }>;
  selected: OtherTransferBeneficiary[];
  onToggle: (contact: {
    id: number;
    firstName: string;
    lastName: string;
  }) => void;
}) {
  return (
    <div className="space-y-3">
      <Label className="text-foreground-secondary text-sm font-medium">
        Transfer to
      </Label>
      <div className="space-y-1.5">
        {contacts.map((contact) => {
          const isSelected = selected.some((s) => s.contactId === contact.id);
          const name =
            [contact.firstName, contact.lastName].filter(Boolean).join(' ') ||
            '—';
          return (
            <div
              key={contact.id}
              className={cn(
                'flex items-center gap-2 rounded-md border px-3 py-2 transition-colors',
                isSelected
                  ? 'border-border-strong bg-surface-subtle/40'
                  : 'border-border-subtle bg-card'
              )}
            >
              <Checkbox
                checked={isSelected}
                onCheckedChange={() => onToggle(contact)}
                id={`other-ben-${contact.id}`}
              />
              <Label
                htmlFor={`other-ben-${contact.id}`}
                className="text-foreground flex-1 cursor-pointer text-sm font-medium"
              >
                {name}
              </Label>
            </div>
          );
        })}
      </div>
      {selected.length > 1 && (
        <p className="text-muted-foreground text-xs">
          Items transfer jointly, with no percentage split.
        </p>
      )}
    </div>
  );
}
